import { compose, pure, withProps } from 'recompose'
import * as R from 'ramda'
import { Button, A } from './styles'

const enhance = compose(
  withProps(props => ({
    smartComponent: R.cond([
      // if we need to disable this button, we should actually
      // just render a button because you can't really disable
      // an <a> element. This is the best way to do this.
      [
        R.and(R.has('disabled'), R.propEq('disabled', true)),
        makeButtonComponent,
      ],
      [R.has('href'), makeAnchorComponent],
      [R.T, makeButtonComponent],
    ])(props),
  })),
  pure,
)

export default enhance

// ---------

function makeAnchorComponent(props) {
  return {
    SmartButton: A,
    // Regular DOM elements can't have react props
    // `A` uses withComponent to generate an <a> tag
    safeProps: R.omit(['iconPosition', 'next'], props),
  }
}

function makeButtonComponent(props) {
  return {
    SmartButton: Button,
    // Button accepts all props because it's
    // a styled component.
    safeProps: {
      ...props,
      hasIcon: props.icon || props.next,
    },
  }
}
